import { useClassNames } from '@magnetic/hooks';
import { consoleWarn } from '@magnetic/lib';
import React, { forwardRef } from 'react';
import './styles.css.js';

const sizeMap = {
  xxxs: "p4",
  xxs: "p3",
  xs: "p2",
  sm: "p1",
  p1: "p1",
  p2: "p2",
  p3: "p3",
  p4: "p4"
};
const Text = forwardRef(
  ({
    align,
    as,
    className,
    color = "regular",
    compact,
    ellipsis = false,
    monospace,
    size = "p3",
    style,
    weight = "regular",
    width,
    ...rest
  }, ref) => {
    const Component = as || "p";
    const applyPresetColor = ["light", "regular"].includes(color);
    const classNames = useClassNames(
      "mds-text",
      `mds-text-${sizeMap[size]}`,
      `mds-text-weight-${weight}`,
      {
        "mds-text-monospace": monospace,
        "mds-text-compact": compact,
        "mds-text-ellipsis": ellipsis,
        [`mds-text-color-${color}`]: applyPresetColor
      },
      className
    );
    consoleWarn({
      prop: size,
      propValues: ["xxxs", "xxs", "xs", "sm"],
      message: "The use of t-shirt sizes in the `Text` component is deprecated and will be removed in a future major release of Magnetic in order to align terminology between design and engineering. Please use p1 through p4 as they appear in your Figma designs in the inpector tab under the Typography section."
    });
    const computedStyles = {
      ...align && { textAlign: align },
      ...style,
      ...color && !applyPresetColor && { color },
      ...width && { width }
    };
    return /* @__PURE__ */ React.createElement(Component, {
      className: classNames,
      ref,
      style: computedStyles,
      ...rest
    });
  }
);

export { Text };
//# sourceMappingURL=index.js.map
